export const theme= {
  primary: {
    600: '#CDCDCD', //Celdas inactivas
    900: '#F2F2F2', //Fondo de guia
  },
  grey: { 300: '#2E2E2E' }, //Titulo de Programacion
  white: '#607080', 
  green: { //Indicador de Tiempo Actual
    300: 'linear-gradient(180deg, #ff9e00 0%, #ff0000 33.93%, #b5007d 58.36%, #21429c 82.54%, #0071ff 100%)',
  },
  loader: { //Not used
    teal: "#FF9E00",
    purple: "#ff0000",
    pink: "#b5007d",
    bg: "#21429c"
  },
  scrollbar: {
    border: '#ffffff', // Yet Unknown
    thumb: { // Handles scrollbar
      bg: '#718096', 
    },
  },
  
  gradient: { //Gradiente para celdas de programacion
    blue: {
      300: '#CDCDCD', 
      600: '#E0E0E0',
      900: '#F2F2F2',
    },
  },

  text: {
    grey: {
      300: '#2E2E2E', //Horas de Timebar
      500: '#8e8e8e', //Horario de Programacion
    },
  },
  
  epg :{
    width:5, 
  },

  timeline: {
    width:10,
    divider: { //Divisioores de media hora en timebar
      bg: '#000FBE',
      width: 100,
    },
  },
};